module.exports = __webpack_public_path__ + "img/story-3.b9489d63.png";